import * as React from "react";
import classNames from "classnames";

import classes from "./Label.module.scss";

interface IProps {
	text: string;
	children?: JSX.Element | JSX.Element[];
	textStyleClass?: string;
}

export const Label = ({ text, children, textStyleClass }: IProps) => (
	<div className={classes.label}>
		<div className={classes.label__column}>
			<div className={classNames(classes.label__text, textStyleClass)}>
				{text}
			</div>
			<div className={classes.label__children}>
				{children}
			</div>
		</div>
	</div>
);
